<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="90%">
    <v-card>
      <v-card-title class="pa-0">
        <v-col class="text-end py-0 px-0" cols="12">
          <v-btn class="pa-0" icon dark @click="clean()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center pt-0" cols="12">
          <h1 style="font-size: 24px" class="mb-3 mt-0">


            <template v-if="exibir_historico">Histórico de Pendência</template>
            <template v-else-if="formData.id">Concluir Pendência</template>
            <template v-else-if="info.etapa<99">Incluir Pendência</template>
          </h1>
          <span ><!--v-if="origem != 'lista'"-->
            <p style="font-size: 14px; line-height: 18px" class="mb-2 text-center">
              Gerencie uma pendência por vez.
            </p>
            <button @click="()=>{exibir_historico = !exibir_historico}" class="button-histor pa-0" v-if="pendencias.length>0 && !exibir_historico">
              <v-icon class="py-0 px-1" color="primary" x-small>fas fa-clock</v-icon>
              <b style="font-size:12px;color:#118ACA">Histórico de pendências</b>
            </button>
            <button @click="()=>{exibir_historico = !exibir_historico}" class="button-histor pa-0" v-else-if="pendencias.length>0 && formData.id">
              <v-icon class="py-0 px-1" color="primary" x-small>fas fa-pencil-alt</v-icon>
              <b style="font-size:12px;color:#118ACA">Concluir pendência</b>
            </button>
            <button @click="()=>{exibir_historico = !exibir_historico}" class="button-histor pa-0" v-if="info.etapa<99">
              <v-icon class="py-0 px-1" color="primary" x-small>fas fa-pencil-alt"</v-icon>
              <b style="font-size:12px;color:#118ACA">Incluir pendência</b>
            </button>
          </span>
        </v-col>
      </v-card-title>
      <v-card-text v-if="exibir_historico" class="px-10 pb-1" >
        <v-data-table dense :headers="headers" :items="pendencias" hide-default-footer v-if="pendencias.length > 0">
          <template v-slot:item="props">
            <tr>
              <td class="text-left pa-2">{{ getMotivo(props.item.pendencia_recurso_tipo_id) }}</td>
              <td class="text-center pa-2">{{ props.item.data_inclusao | formatDateTime }}</td>
              <td class="text-left pa-2">{{ props.item.username_inclusao}}</td>
              <td class="text-left pa-2">{{ getMensagem(props.item.mensagem, 'inclusao') }}</td>
              <td class="text-center pa-2">{{ props.item.data_conclusao | formatDateTime }}</td>
              <td class="text-left pa-2">{{ props.item.username_conclusao}}</td>
              <td class="text-left pa-2">{{ getMensagem(props.item.mensagem, 'conclusao') }}</td>
            </tr>
          </template>
        </v-data-table>
        <span v-else class="text-center">Não há histórico de pendências para este pagamento</span>
      </v-card-text>
      <v-card-text v-else class="px-10 pt-0 pb-6" >
        <v-form ref="pendenciaRecursoForm" :value="formValid">
        <v-row>
        <v-col class="px-2" cols="6" v-if="!formData.id">
        <div class="title-form">Motivo da pendência</div>
        <v-select
          v-model="formData.pendencia_recurso_tipo_id"
          :menu-props="{ bottom: true, offsetY: true }"
          solo
          flat
          dense
          :items="motivosList"
          item-text="descricao"
          item-value="id"
          outlined
          :disable="formData.id"
        ></v-select>
      </v-col>
      <!-- <v-col class="px-2" cols="6" v-if="formData.id">
          <v-switch
            v-model="formData.concluir"
            label="Concluir pendência"
            color="primary"
            class="mr-0"
            ></v-switch>
        </v-col> -->
            <v-col class="px-2" cols="12">
              <p v-if="formData.id">Incluído em <b>{{pendencias[0].data_inclusao | formatDateTime}}</b>
                por <b>{{pendencias[0].username_inclusao}}</b><br>
                Mensagem: <b>{{getMensagem(pendencias[0].mensagem, 'inclusao')}}</b></p>
                <label>Mensagem</label>
                <v-textarea
                    v-model="formData.mensagem"
                    persistent-hint
                    outlined
                    dense
                    :rules="[this.formRules.max150]"
                  ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-6 pb-1 pt-2" >
        <v-col class="text-left px-4 pb-4 pt-0" cols="6">
          <v-btn
            height="30px"
            small
            color="primary"
            depressed
            outlined
            @click="clean()"
          >
            {{!exibir_historico? "Cancelar":"fechar"}}
          </v-btn>
        </v-col>
        <v-col class="text-right px-5 pb-6 pt-0" cols="6" v-if="!exibir_historico">
           <v-btn v-if="formData.id"
            height="30px"
            class="mr-3"
            small
            color="error"
            depressed
            :disable="!formData.concluir"
            @click="SavePendenciaConfirm(true)"
          >
            Concluir pendência
          </v-btn>
          <v-btn v-else-if="info.etapa < 99"
            color="primary" height="30px" small depressed @click="SavePendenciaConfirm(false)">
            <template>Incluir pendência</template> 
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      dateFormatted: null,
      exibir_historico: false,
      formData: {
        concluir: false,
        data_pagamento: null,
        id: null,
        mensagem: null,
        operadora_ans_id: null, 
        pagamento_id: null,
        pendencia_recurso_tipo_id: null,
        prestador_id:null, 
      },
      formValid: true,
      motivosList: [],
      pendencias:[],
      headers: [
        { text: "Tipo da pendência:", align: "left", sortable: false },
        { text: "Data da inclusão:", align: "left", sortable: false },
        { text: "Usuário da inclusao", align: "left", sortable: false },
        { text: "Mensagem da inclusao", align: "left", sortable: false },
        { text: "Data da conclusão", sortable: false },
        { text: "Usuário da conclusao", align: "left", sortable: false },
        { text: "Mensagem da conclusao", align: "left", sortable: false }
      ],
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  beforeMount() {
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "GetMotivosPendenciaRecurso",
              payload: {
                grupo_economico: this.grupoEconomico,
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.motivosList = response.dados;
        })
  },
  mounted() {
    if(this.$refs && this.$refs.pendenciaRecursoForm){
          this.$refs.pendenciaRecursoForm.resetValidation()
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.exibir_historico = false;
        this.clean();
      } else {
        let { data_pagamento, operadora_ans_id, id, prestador_id} = this.info
        this.formData = {...this.formData,
          data_pagamento, operadora_ans_id, pagamento_id: id, prestador_id
        };
        if(this.origem == 'lista'){
          this.exibir_historico = true
        }
        this.getHistoricoPendencias(id);
        if(this.$refs && this.$refs.pendenciaRecursoForm){
          this.$refs.pendenciaRecursoForm.resetValidation()
        }
      }
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    clean() {
      if(this.$refs && this.$refs.pendenciaRecursoForm){
          this.$refs.pendenciaRecursoForm.reset();
          this.$refs.pendenciaRecursoForm.resetValidation();
        }
      this.close();
    },
    getHistoricoPendencias(pagamento_id){
      let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "GetHistoricoPendencias",
              payload: {
                grupo_economico: this.grupoEconomico,
                pagamento_id
              },
            },
          ],
        };
          this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response)=>{
            if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.pendencias = response.dados;
          if(this.pendencias.length> 0 && this.pendencias[0].id > 0 && this.pendencias[0].data_conclusao == null)
             this.formData = Object.assign(this.formData, this.pendencias[0]);
            this.formData.mensagem = null;
          if(this.formData.id == null && this.pendencias.length > 0)
            this.exibir_historico = true
          }) 
    },
    getMensagem(mensagem, tipo){
      let array_mensagem = mensagem != null && mensagem != ""? mensagem.split('|conclusao|') : "";
      if(tipo=='inclusao')
        return array_mensagem[0]
      else 
        return array_mensagem[1]
    },
    getMotivo(tipo){
       let motivo = this.motivosList.filter(el=> el.id == tipo)[0].descricao;
       console.log(this.motivosList.filter(el=> el.id == tipo)[0])
       return motivo
    },
    SavePendenciaConfirm(concluir){
      console.log(this.motivosList.filter(el=> el.id == this.formData.pendencia_recurso_tipo_id)[0].descricao)
      let mensagem = concluir? "Deseja realmente concluir a pendência?": 
      `Deseja realmente incluir a pendência?<br>
      Motivo: <b>` + this.motivosList.filter(el=> el.id == this.formData.pendencia_recurso_tipo_id)[0].descricao
      + "</b><br>mensagem: <b>"+ this.formData.mensagem + `</b>`
      let paramModal = {
          type: "warning",
          title: "Edição de pendência",
          message: mensagem,
          callback: () => this.SavePendencia(),
          btConfirm: { name: concluir?"Concluir":"Incluir", show: true, color: 'warning'},
          btCancel: { name: "Não", show: true },
        };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);  
    },
    SavePendencia() {
      if (this.$refs.pendenciaRecursoForm.validate()) {
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "savependenciarecurso",
              payload: {
                grupo_economico: this.grupoEconomico,
                ...this.formData
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            let paramModal = {
                type: "success",
                title: "Sucesso",
                message: response.mensagem,
                callback: ()=> {this.updatePage();  this.clean()},
                btConfirm: { name: "Ok", show: true },
                btCancel: { name: "Não", show: false },
              };
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });
      }
    },
  },
  props: {
    close: Function,
    dialog: Boolean,
    grupoEconomico: Number,
    info: Object,
    origem: String,
    pendencia: Object,
    updatePage: Function
  },
};
</script>

<style>
.button-histor:focus {
  outline: none;
}
.card-title-form-guia {
  font-size: 0.90rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
.textsRec {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}
</style>